<template>
  <main
    id="stock"
    class="page-container stock-list"
    v-if="$route.name === 'tiles'"
  >
    <div class="table-container-stock">
      <div class="items-toolbar">
        <router-link to="/home/stock/tiles/add-item" class="primary-btn">
          + Nuova piastrella
        </router-link>
      </div>
      <div class="tbl-wrap">
        <table ref="fitTable" class="tbl item-table">
          <thead>
            <tr>
              <!-- Nuova colonna per l'immagine -->
              <!-- <th></th> -->
              <th id="item-name">Tipo</th>
              <th id="item-measure">Misura</th>
              <th id="item-per-box" class="col-secondary">In ogni scatola</th>
              <th id="sqm-per-box" class="col-secondary">M² scatola</th>
              <th id="boxes">Scatole in magazzino</th>
              <th id="venduti" class="col-secondary">Venduti</th>
              <th id="total-sqm" class="col-secondary">M² totali</th>
              <th id="item-price">Prezzo</th>
              <!-- rimuovere in favore di 'In Magazzino'-->
              <th id="date" class="col-secondary">Data inserimento</th>
              <!-- [mobile] intestazione della colonna azioni, come in Sanitari -->
              <th class="actions-col"></th>
            </tr>
          </thead>
          <tbody>
            <!-- Per ogni item, aggiungiamo la miniatura -->
            <template v-for="(item, index) in itemsByThisCategory" :key="index">
              <tr
                class="item-row row-clickable"
                @click="onRowClick($event, item)"
              >
                <!-- <td>
                <img
                  v-if="item.image"
                  :src="item.image"
                  alt="Immagine articolo"
                  class="mini-image"
                />
              </td> -->
                <td>{{ item.itemName }}</td>
                <td>{{ item.measureDesc }}</td>
                <td class="col-secondary">{{ item.piecesPerBox }}</td>
                <td class="col-secondary">{{ item.sqmPerBox }}</td>
                <td>{{ item.boxQuantity }}</td>
                <td class="venduti-cell col-secondary">
                  <span
                    v-if="vendutiInfo(item).needsProcurement"
                    class="venduti venduti--procure"
                    :title="`${vendutiInfo(item).warehouse} da magazzino + ${
                      vendutiInfo(item).procure
                    } da ordinare${
                      vendutiInfo(item).soldClients
                        ? ' — clienti: ' + vendutiInfo(item).soldClients
                        : ''
                    }`"
                  >
                    {{ vendutiInfo(item).sold }}
                    <span class="badge-procure">
                      da ordinare {{ vendutiInfo(item).procure }}
                    </span>
                  </span>
                  <span v-else class="venduti">
                    {{ vendutiInfo(item).sold }}
                    <span
                      v-if="vendutiInfo(item).sold > 0"
                      class="badge-committed"
                      :title="
                        vendutiInfo(item).soldClients
                          ? 'Impegnato per: ' + vendutiInfo(item).soldClients
                          : 'Unità già impegnate su preventivi confermati'
                      "
                    >
                      <template v-if="vendutiInfo(item).soldClients">
                        impegnato: {{ vendutiInfo(item).soldClients }}
                      </template>
                      <template v-else>impegnato per clienti</template>
                    </span>
                  </span>
                </td>
                <td class="col-secondary">{{ item.sqmTotal }}</td>
                <td class="price-cell">{{ formatPriceToPrint(item.price) }}</td>
                <td class="col-secondary">
                  {{ formatToLocalDate(item.entryDate) }}
                </td>
                <td class="actions-cell">
                  <button
                    v-if="vendutiInfo(item).needsProcurement"
                    class="icons-button"
                    @click="openProcureModal(item)"
                    title="Ordina la quantità mancante"
                    aria-label="Ordina articolo"
                  >
                    <i class="fa-solid fa-truck-fast"></i>
                  </button>
                  <button
                    class="icons-button"
                    @click="goToEditItem(item.id)"
                    title="Modifica piastrella"
                    aria-label="Modifica piastrella"
                  >
                    <i class="fa-solid fa-pen-to-square"></i>
                  </button>
                  <button
                    class="icons-button"
                    @click="openArchiveModal(item)"
                    title="Archivia piastrella"
                    aria-label="Archivia piastrella"
                  >
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </td>
              </tr>
              <!-- Riga per le icone in versione mobile: aggiorna il colspan in base al numero di colonne -->
              <!-- <tr>
                <td class="mobile-icons" colspan="9">
                  <button class="icons-button" @click="goToEditItem(item.id)">
                    <i class="fa-solid fa-pen-to-square"></i>
                  </button>
                  <button class="icons-button" @click="onArchiveItem(item.id)">
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </td>
              </tr> -->
            </template>
          </tbody>
        </table>
      </div>
      <div class="pagination">
        <div class="search-container">
          <input
            type="text"
            v-model="searchTerm"
            @keyup.enter="onSearch"
            placeholder="Cerca piastrelle..."
            class="search-box"
          />
          <button
            v-if="searchTerm"
            @click="onResetSearch"
            class="clear-search-button"
          >
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
        <div class="pagination-info">
          {{ pagination.startItem }}-{{ pagination.endItem }} di
          {{ pagination.totalItems }}
        </div>

        <div class="pagination-controls">
          <!-- vai alla prima pagina -->
          <button
            class="icons-button"
            @click="goToPage(1)"
            :disabled="pagination.currentPage === 1"
            :title="
              pagination.currentPage === 1 ? null : 'Torna alla prima pagina'
            "
          >
            <i class="fa-solid fa-angles-left"></i>
          </button>
          <button
            class="icons-button"
            @click="goToPage(pagination.currentPage - 1)"
            :disabled="pagination.currentPage === 1"
            :title="
              pagination.currentPage === 1
                ? null
                : 'Torna alla pagina precedente'
            "
          >
            <i class="fa-solid fa-chevron-left"></i>
          </button>

          <button
            v-for="pageNum in visiblePages"
            :key="pageNum"
            @click="goToPage(pageNum)"
            :class="{ active: pagination.currentPage === pageNum }"
            class="pages-button"
          >
            {{ pageNum }}
          </button>

          <button
            class="icons-button"
            @click="goToPage(pagination.currentPage + 1)"
            :disabled="pagination.currentPage === pagination.totalPages"
            :title="
              pagination.currentPage === pagination.totalPages
                ? null
                : 'Vai alla pagina successiva'
            "
          >
            <i class="fa-solid fa-chevron-right"></i>
          </button>
          <!-- vai all'ultima pagina -->
          <button
            class="icons-button"
            @click="goToPage(pagination.totalPages)"
            :disabled="pagination.currentPage === pagination.totalPages"
            :title="
              pagination.currentPage === pagination.totalPages
                ? null
                : `Vai all'ultima pagina`
            "
          >
            <i class="fa-solid fa-angles-right"></i>
          </button>
        </div>
      </div>
    </div>
    <!-- MODALE ARCHIVIAZIONE -->
    <VueFinalModal
      v-model="showArchiveModal"
      :clickToClose="!archiving"
      :escToClose="!archiving"
      classes="documents-modal"
      content-class="confirm-modal-content modal--archive"
    >
      <template #default>
        <button
          class="modal__close icons-button"
          @click="closeArchiveModal"
          :disabled="archiving"
          title="Chiudi"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>

        <h3 class="modal__title">Archivia piastrella</h3>
        <p class="modal__subtitle">
          Archiviare l'articolo
          <strong>{{ selectedItem?.itemName || selectedItem?.brand }}</strong>
        </p>

        <div class="modal-actions">
          <button
            class="secondary-btn"
            @click="closeArchiveModal"
            :disabled="archiving"
          >
            Annulla
          </button>
          <button
            class="primary-btn confirm-btn"
            @click="confirmArchive"
            :disabled="archiving"
          >
            <span v-if="archiving">Archivia…</span>
            <span v-else>Archivia</span>
          </button>
        </div>
      </template>
    </VueFinalModal>

    <WarehouseProcureModal
      v-model="showProcureModal"
      :item="procureItem"
      unit="scatole"
      @procured="onProcured"
    />

    <!-- [sc-49210] Dettaglio riga: le colonne secondarie -->
    <RowDetailsModal
      v-model="showRowDetails"
      :title="
        [rowDetailsItem?.itemName, rowDetailsItem?.measureDesc]
          .filter(Boolean)
          .join(' - ') || 'Piastrella'
      "
    >
      <template v-if="rowDetailsItem">
        <div>
          <dt>In ogni scatola</dt>
          <dd>{{ rowDetailsItem.piecesPerBox }}</dd>
        </div>
        <div>
          <dt>M² scatola</dt>
          <dd>{{ rowDetailsItem.sqmPerBox }}</dd>
        </div>
        <div>
          <dt>Venduti</dt>
          <dd>
            <span
              v-if="vendutiInfo(rowDetailsItem).needsProcurement"
              class="venduti venduti--procure"
              :title="`${
                vendutiInfo(rowDetailsItem).warehouse
              } da magazzino + ${
                vendutiInfo(rowDetailsItem).procure
              } da ordinare${
                vendutiInfo(rowDetailsItem).soldClients
                  ? ' — clienti: ' + vendutiInfo(rowDetailsItem).soldClients
                  : ''
              }`"
            >
              {{ vendutiInfo(rowDetailsItem).sold }}
              <span class="badge-procure">
                da ordinare {{ vendutiInfo(rowDetailsItem).procure }}
              </span>
            </span>
            <span v-else class="venduti">
              {{ vendutiInfo(rowDetailsItem).sold }}
              <span
                v-if="vendutiInfo(rowDetailsItem).sold > 0"
                class="badge-committed"
                :title="
                  vendutiInfo(rowDetailsItem).soldClients
                    ? 'Impegnato per: ' +
                      vendutiInfo(rowDetailsItem).soldClients
                    : 'Unità già impegnate su preventivi confermati'
                "
              >
                <template v-if="vendutiInfo(rowDetailsItem).soldClients">
                  impegnato: {{ vendutiInfo(rowDetailsItem).soldClients }}
                </template>
                <template v-else>impegnato per clienti</template>
              </span>
            </span>
          </dd>
        </div>
        <div>
          <dt>M² totali</dt>
          <dd>{{ rowDetailsItem.sqmTotal }}</dd>
        </div>
        <div>
          <dt>Data inserimento</dt>
          <dd>{{ formatToLocalDate(rowDetailsItem.entryDate) }}</dd>
        </div>
      </template>
    </RowDetailsModal>
  </main>
  <router-view></router-view>
</template>

<script>
import { mapActions, mapGetters } from "vuex/dist/vuex.cjs.js";
import { formatPriceToPrint, formatToLocalDate } from "../utilities/formatting";
import WarehouseProcureModal from "../components/WarehouseProcureModal.vue";
import RowDetailsModal from "@/components/RowDetailsModal.vue";
import { shouldOpenRowDetails } from "@/utilities/rowDetails";
import { fitPageSizeMixin } from "@/utilities/fitPageSize";

export default {
  // [sc-49210] elementi per pagina calcolati dallo schermo (pageSize)
  mixins: [fitPageSizeMixin],
  components: { WarehouseProcureModal, RowDetailsModal },
  data() {
    return {
      errorMessage: "",
      successMessage: "",
      category: "piastrelle",
      selectedItem: null,
      showDocumentsModal: false,
      showArchiveModal: false,
      archiving: false,
      currentPage: 1,
      searchTerm: "",
      showProcureModal: false,
      procureItem: null,
      showRowDetails: false,
      rowDetailsItem: null,
    };
  },
  computed: {
    ...mapGetters({
      allItems: "items/list",
      onlyTiles: "items/list/filtered",
      pagination: "items/pagination",
    }),

    visiblePages() {
      const range = 2; // Numero di pagine da mostrare attorno alla corrente
      const start = Math.max(1, this.pagination.currentPage - range);
      const end = Math.min(
        this.pagination.totalPages,
        this.pagination.currentPage + range
      );
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },

    itemsByThisCategory() {
      if (typeof this.onlyTiles !== "function") return [];
      // filterByCat è la funzione getter
      // console.log("this.onlyTiles: ", this.onlyTiles(this.category));
      return this.onlyTiles(this.category);
    },
  },
  methods: {
    // [sc-49210] il numero di righe che stanno nello schermo è cambiato
    onPageSizeChange() {
      this.currentPage = 1;
      return this.getTiles(1);
    },
    ...mapActions(["fetchItems", "archiveItem"]),
    formatPriceToPrint,
    formatToLocalDate,

    // Venduti aggregati (preventivi confermati) calcolati dal backend:
    // soldQuantity = totale venduto, toProcureQuantity = parte da ordinare.
    vendutiInfo(item) {
      const sold = Number(item.soldQuantity || 0);
      const procure = Number(item.toProcureQuantity || 0);
      const warehouse = Math.max(0, sold - procure);
      return {
        sold,
        warehouse,
        procure,
        needsProcurement: procure > 0,
        soldClients: item.soldClients || "",
      };
    },

    onRowClick(event, item) {
      if (!shouldOpenRowDetails(event)) return;
      this.rowDetailsItem = item;
      this.showRowDetails = true;
    },

    openProcureModal(item) {
      this.procureItem = item;
      this.showProcureModal = true;
    },

    // Ricarico la pagina corrente: il badge "da ordinare" è una SUM lato server.
    async onProcured() {
      this.procureItem = null;
      await this.getTiles(this.pagination.currentPage);
    },

    openArchiveModal(item) {
      this.selectedItem = item;
      this.showArchiveModal = true;
    },

    closeArchiveModal() {
      if (this.archiving) return;
      this.showArchiveModal = false;
      this.selectedItem = null;
    },

    async onSearch() {
      try {
        this.currentPage = 1; // riparti dalla prima pagina
        const res = await this.fetchItems({
          page: 1,
          limit: this.pageSize,
          category: this.category,
          search: this.searchTerm,
        });
        // store ha gestito il 404 ⇒ res === [] e lista già svuotata
        if (
          Array.isArray(res) &&
          res.length === 0 &&
          (this.searchTerm || "").trim()
        ) {
          const msg = "Nessuna piastrella per la ricerca richiesta.";
          this.errorMessage = msg;
          this.$toast.error(msg);
        }
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.details ||
          "Nessuna piastrella per la ricerca richiesta.";
        this.errorMessage = msg;
        this.$toast.error(msg);
      }
    },

    async onResetSearch() {
      try {
        this.currentPage = 1; // riparti dalla prima pagina
        this.searchTerm = "";
        await this.fetchItems({
          page: 1,
          limit: this.pageSize,
          category: this.category,
        });
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.details ||
          "Errore durante il reset della ricerca.";
        this.errorMessage = msg;
        this.$toast.error(msg);
      }
    },

    goToPage(page) {
      if (page < 1 || page > this.pagination.totalPages) return;
      this.getTiles(page);
    },

    async getTiles(page, search = this.searchTerm) {
      try {
        const res = await this.fetchItems({
          page,
          limit: this.pageSize,
          category: this.category,
          search,
        });
        // Se lo store dovesse restituire [] con ricerca attiva
        if (Array.isArray(res) && res.length === 0 && (search || "").trim()) {
          const msg = "Nessuna piastrella per la ricerca richiesta.";
          this.errorMessage = msg;
          this.$toast.error(msg);
        }
      } catch (error) {
        const defaultMsg =
          search && String(search).trim()
            ? "Nessuna piastrella per la ricerca richiesta."
            : "Errore durante il caricamento delle piastrelle.";
        const msg =
          error?.response?.data?.message ||
          error?.response?.data?.details ||
          defaultMsg;
        this.errorMessage = msg;
        this.$toast.error(msg);
      }
    },

    // goFirst() {
    //   if (this.pagination.previous) {
    //     this.currentPage = this.pagination.first.page;
    //     this.getTiles(this.currentPage);
    //   }
    // },

    // goNext() {
    //   if (this.pagination.next) {
    //     this.currentPage = this.pagination.next.page;
    //     this.getTiles(this.currentPage);
    //   }
    // },
    // goPrev() {
    //   if (this.pagination.previous) {
    //     this.currentPage = this.pagination.previous.page;
    //     this.getTiles(this.currentPage);
    //   }
    // },
    // goLast() {
    //   if (this.pagination.last) {
    //     this.currentPage = this.pagination.last.page;
    //     this.getTiles(this.currentPage);
    //   }
    // },

    goToEditItem(itemId) {
      this.$router.push({ name: "tiles-edit-item", params: { itemId } });
    },
    // async onArchiveItem(itemId) {
    //   const conferma = window.confirm(
    //     "Sei sicuro di voler archiviare l'articolo?"
    //   );
    //   if (!conferma) return;
    //   try {
    //     await this.archiveItem(itemId);
    //     this.successMessage = "Articolo archiviato con successo.";
    //   } catch (err) {
    //     console.error(err);
    //     this.errorMessage = "Impossibile archiviare l'articolo.";
    //   }
    // },
    async confirmArchive() {
      if (!this.selectedItem) return;
      try {
        this.archiving = true;
        let response;
        if (this.$store._actions?.archiveItem) {
          response = await this.archiveItem(this.selectedItem.id);
        } else {
          response = await this.$axios.patch(
            `item/archive/${this.selectedItem.id}`,
            JSON.stringify({ archived: true })
          );
        }
        this.successMessage =
          response.data?.message || "Articolo archiviato con successo.";
        this.$toast.success(this.successMessage);
        this.showArchiveModal = false;

        // await this.refreshArchivedFlag();
        await this.fetchItems({
          page: this.pagination.currentPage,
          limit: this.pageSize,
          search: this.searchTerm,
          category: this.category,
          // archived: this.showArchived,
        });
        if (
          this.pagination.currentPage > this.pagination.totalPages &&
          this.pagination.totalPages >= 1
        ) {
          await this.fetchItems({
            page: this.pagination.totalPages,
            limit: this.pageSize,
            search: this.searchTerm,
          });
        }
      } catch (err) {
        this.errorMessage =
          err.response?.data?.details ||
          "Impossibile archiviare il l'articolo.";
        this.$toast.error(this.errorMessage);
      } finally {
        this.archiving = false;
        this.selectedItem = null;
      }
    },
  },
  mounted() {
    this.getTiles(this.currentPage).then(() => this.fitPageSize());
  },
};
</script>

<style src="@/css/StockPage.css" />
